function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import PairingChannelClientErrors from '../../lib/pairing-channel-client-errors';
import { State } from './state';
import PairingFlowStateMachine from './state-machine';
/* eslint-disable no-use-before-define */

let SupplicantState = /*#__PURE__*/function (_State) {
  _inherits(SupplicantState, _State);

  var _super = _createSuper(SupplicantState);

  function SupplicantState(attributes) {
    var _this;

    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SupplicantState);

    _this = _super.call(this, attributes, options);
    _this.pairingChannelClient = options.pairingChannelClient;

    _this.listenTo(_this.pairingChannelClient, 'close', () => _this.socketClosed());

    _this.listenTo(_this.pairingChannelClient, 'error', error => _this.socketError(error));

    return _this;
  }

  _createClass(SupplicantState, [{
    key: "socketClosed",
    value: function socketClosed() {
      this.navigate('pair/failure', {
        error: PairingChannelClientErrors.toError('CONNECTION_CLOSED')
      });
    }
  }, {
    key: "socketError",
    value: function socketError(error) {
      this.navigate('pair/failure', {
        error
      });
    }
  }]);

  return SupplicantState;
}(State);

let WaitForConnectionToChannelServer = /*#__PURE__*/function (_SupplicantState) {
  _inherits(WaitForConnectionToChannelServer, _SupplicantState);

  var _super2 = _createSuper(WaitForConnectionToChannelServer);

  function WaitForConnectionToChannelServer() {
    var _this2;

    _classCallCheck(this, WaitForConnectionToChannelServer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this2), "name", 'WaitForConnectionToChannelServer');

    _this2.listenTo(_this2.pairingChannelClient, 'connected', () => {
      _this2.gotoState(SendOAuthRequestWaitForAccountMetadata);
    });

    return _this2;
  }

  _createClass(WaitForConnectionToChannelServer, [{
    key: "socketClosed",
    value: function socketClosed() {// do nothing on connection closed
    }
  }]);

  return WaitForConnectionToChannelServer;
}(SupplicantState);

let SendOAuthRequestWaitForAccountMetadata = /*#__PURE__*/function (_SupplicantState2) {
  _inherits(SendOAuthRequestWaitForAccountMetadata, _SupplicantState2);

  var _super3 = _createSuper(SendOAuthRequestWaitForAccountMetadata);

  function SendOAuthRequestWaitForAccountMetadata() {
    var _this3;

    _classCallCheck(this, SendOAuthRequestWaitForAccountMetadata);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this3), "name", 'WaitForAccountMetadata');

    _this3.pairingChannelClient.send('pair:supp:request', _this3.relier.getOAuthParams()).then(() => {
      _this3.listenTo(_this3.pairingChannelClient, 'remote:pair:auth:metadata', data => {
        _this3.broker.setRemoteMetaData(data.remoteMetaData);

        _this3.gotoState(WaitForAuthorizations, data);
      });
    });

    return _this3;
  }

  return _createClass(SendOAuthRequestWaitForAccountMetadata);
}(SupplicantState);

function onAuthAuthorize(NextState, result) {
  return Promise.resolve().then(() => {
    this.relier.validateApprovalData(result);
    const code = result.code;
    this.relier.set({
      code
    });
    this.gotoState(NextState);
  }).catch(err => this.trigger('error', err));
}

let WaitForAuthorizations = /*#__PURE__*/function (_SupplicantState3) {
  _inherits(WaitForAuthorizations, _SupplicantState3);

  var _super4 = _createSuper(WaitForAuthorizations);

  function WaitForAuthorizations() {
    var _this4;

    _classCallCheck(this, WaitForAuthorizations);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this4), "name", 'WaitForApprovals');

    _defineProperty(_assertThisInitialized(_this4), "onAuthorityAuthorize", onAuthAuthorize.bind(_assertThisInitialized(_this4), WaitForSupplicantAuthorize));

    _this4.navigate('pair/supp/allow', {
      deviceName: _this4.get('deviceName')
    });

    _this4.listenTo(_this4.pairingChannelClient, 'remote:pair:auth:authorize', _this4.onAuthorityAuthorize);

    _this4.listenTo(_this4.notifier, 'pair:supp:authorize', () => {
      _this4.pairingChannelClient.send('pair:supp:authorize').then(() => {
        _this4.gotoState(WaitForAuthorityAuthorize);
      });
    });

    return _this4;
  }

  return _createClass(WaitForAuthorizations);
}(SupplicantState);

let WaitForSupplicantAuthorize = /*#__PURE__*/function (_SupplicantState4) {
  _inherits(WaitForSupplicantAuthorize, _SupplicantState4);

  var _super5 = _createSuper(WaitForSupplicantAuthorize);

  function WaitForSupplicantAuthorize() {
    var _this5;

    _classCallCheck(this, WaitForSupplicantAuthorize);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this5), "name", 'WaitForSupplicantAuthorize');

    _this5.listenTo(_this5.notifier, 'pair:supp:authorize', () => {
      _this5.pairingChannelClient.send('pair:supp:authorize').then(() => {
        return _this5.gotoState(SendResultToRelier);
      });
    });

    return _this5;
  }

  return _createClass(WaitForSupplicantAuthorize);
}(SupplicantState);

let WaitForAuthorityAuthorize = /*#__PURE__*/function (_SupplicantState5) {
  _inherits(WaitForAuthorityAuthorize, _SupplicantState5);

  var _super6 = _createSuper(WaitForAuthorityAuthorize);

  function WaitForAuthorityAuthorize() {
    var _this6;

    _classCallCheck(this, WaitForAuthorityAuthorize);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this6), "name", 'WaitForAuthorityAuthorize');

    _defineProperty(_assertThisInitialized(_this6), "onAuthorityAuthorize", onAuthAuthorize.bind(_assertThisInitialized(_this6), SendResultToRelier));

    _this6.navigate('pair/supp/wait_for_auth');

    _this6.listenTo(_this6.pairingChannelClient, 'remote:pair:auth:authorize', _this6.onAuthorityAuthorize);

    return _this6;
  }

  return _createClass(WaitForAuthorityAuthorize);
}(SupplicantState);

let SendResultToRelier = /*#__PURE__*/function (_SupplicantState6) {
  _inherits(SendResultToRelier, _SupplicantState6);

  var _super7 = _createSuper(SendResultToRelier);

  function SendResultToRelier() {
    var _this7;

    _classCallCheck(this, SendResultToRelier);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args)); // causes the channel to be closed by the remote end.
    // The next State will do nothing.

    _defineProperty(_assertThisInitialized(_this7), "name", 'SendResultToRelier');

    _this7.broker.sendCodeToRelier().then(() => {
      _this7.gotoState(State);
    }).catch(err => _this7.trigger('error', err));

    return _this7;
  }

  _createClass(SendResultToRelier, [{
    key: "socketClosed",
    value: function socketClosed() {// do nothing, this is expected to happen
    }
  }]);

  return SendResultToRelier;
}(SupplicantState);

let SupplicantStateMachine = /*#__PURE__*/function (_PairingFlowStateMach) {
  _inherits(SupplicantStateMachine, _PairingFlowStateMach);

  var _super8 = _createSuper(SupplicantStateMachine);

  function SupplicantStateMachine(attrs) {
    var _this8;

    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, SupplicantStateMachine);

    _this8 = _super8.call(this, attrs, options);

    _this8.createState(WaitForConnectionToChannelServer);

    return _this8;
  }

  return _createClass(SupplicantStateMachine);
}(PairingFlowStateMachine);

export default SupplicantStateMachine;
export { SupplicantState, WaitForConnectionToChannelServer, SendOAuthRequestWaitForAccountMetadata, WaitForAuthorizations, WaitForSupplicantAuthorize, WaitForAuthorityAuthorize, SendResultToRelier, SupplicantStateMachine };
/* eslint-enable no-use-before-define */